import { Component, Input } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap';
import { ToasterService } from 'angular2-toaster';
import * as _ from 'lodash';

import { Store } from '@ngrx/store';
import * as fromCommonStore from '../../store';
import * as commonActions from '../../store/actions/common.actions';
import * as fromRootStore from '../../reducers';

import { PrintPreview } from './print.preview';

@Component({
    selector: 'print-page',
    template: `
     <button md-mini-fab color="accent" (click)="printPreview()" mdTooltip="PRINT">
         <i class="fa fa-print"></i>
     </button>
    `
})
export class PrintPage {
    @Input() config : any[] = [];

	opt: any;
	defaults = {
        debug: false,           // show the iframe for debugging
        importCSS: false,        // import parent page css
        importStyle: false,     // import style tags
        printContainer: true,   // print outer container/$.selector
        loadCSS: "",            // load an additional css file - load multiple stylesheets with an array []
        pageTitle: "",          // add title to print page
        removeInline: false,    // remove all inline styles
        printDelay: 333,        // variable print delay
        header: null,           // prefix to html
        footer: null,           // postfix to html
        formValues: true,       // preserve input/form values
        canvas: false,          // copy canvas content (experimental)
        base: false,            // preserve the BASE tag, or accept a string for the URL
        doctypeString: '<!DOCTYPE html>', // html doctype
        removeScripts: false,   // remove script tags before appending
        copyTagClasses: false   // copy classes from the html & body tag
    };

    constructor(public store: Store<fromRootStore.State>,private modalService: BsModalService, public toasterService: ToasterService) {

    }
    ngOnDestroy() {
        // prevent memory leak when component destroyed
        //this.subscribeService.publishReloadClientWalkInGrid().unsubscribe();
        if (!_.isEmpty(this.subscribeAuth)) {
        this.subscribeAuth.unsubscribe();
        }
    }
    printModalRef: BsModalRef;
    subscribeAuth;
    cssPathName = '';
    printPreview() {
        //alert('printPreview');
        /*this.printThis($('.ngx-datatable'), {
        	loadCSS: ['/assets/css/print.css']
        });*/
        let that = this;
        this.printModalRef = this.modalService.show(PrintPreview, {
            keyboard: false,
            ignoreBackdropClick: true,
            class:'modal-lg compWidth-96'
        });
        this.printModalRef.content.printData = Object.assign({}, this.config);
        //TO GET PRINT CSS PATH NAME 
        this.subscribeAuth = this.store.select(fromCommonStore.getAuth).subscribe((auth: any) => {
            if (auth['islogin']) {
                if(that['config']['type'] == 'hvPrint'){
                    that.cssPathName = auth['hvPrintCssPath'];
                }else {
                    that.cssPathName = auth['printCssName'];
                }
            }console.log(that.cssPathName);
        });
        this.printModalRef.content.printEvent.subscribe(($e) => {
            let cssPathName = that.cssPathName || '/assets/css/print.css';
            that.printThis($('#printContent'), {
                loadCSS: [cssPathName]
            });
        });
    }

    appendContent($el, content) {
        if (!content) return;

        // Simple test for a jQuery element
        $el.append(content.jquery ? content.clone() : content);
    }

    appendBody($body, $element, opt) {
        // Clone for safety and convenience
        var $content = $element.clone();

        if (this.opt.removeScripts) {
            $content.find('script').remove();
        }

        if (this.opt.printContainer) {
            // grab $.selector as container
            $body.append($("<div/>").html($content).html());
        } else {
            // otherwise just print interior elements of container
            $content.each(function() {
                $body.append($(this).html());
            });
        }
    }

    printThis = function(element, options) {
    	this.opt = $.extend({}, this.defaults, options);
        var $element = element;

        var strFrameName = "printThis-" + (new Date()).getTime();

        if (window.location.hostname !== document.domain && navigator.userAgent.match(/msie/i)) {
            // Ugly IE hacks due to IE not inheriting document.domain from parent
            // checks if document.domain is set by comparing the host name against document.domain
            var iframeSrc = "javascript:document.write(\"<head><script>document.domain=\\\"" + document.domain + "\\\";</s" + "cript></head><body></body>\")";
            var printI = document.createElement('iframe');
            printI.name = "printIframe";
            printI.id = strFrameName;
            printI.className = "MSIE";
            document.body.appendChild(printI);
            printI.src = iframeSrc;

        } else {
            // other browsers inherit document.domain, and IE works if document.domain is not explicitly set
            var $frame = $("<iframe id='" + strFrameName + "' name='printIframe' border='0'/>");
            $frame.appendTo("body");
        }

        var $iframe = $("#" + strFrameName);

        // show frame if in debug mode
        if (!this.opt.debug) $iframe.css({
            position: "absolute",
            width: "0px",
            height: "0px",
            left: "-600px",
            top: "-600px"
        });

        // $iframe.ready() and $iframe.load were inconsistent between browsers
        setTimeout(()=>{

            // Add doctype to fix the style difference between printing and render
            function setDocType($iframe, doctype){
                var win, doc;
                win = $iframe.get(0);
                win = win.contentWindow || win.contentDocument || win;
                doc = win.document || win.contentDocument || win;
                doc.open();
                doc.write(doctype);
                doc.close();
            }

            if (this.opt.doctypeString){
                setDocType($iframe, this.opt.doctypeString);
            }

            var $doc = $iframe.contents(),
                $head = $doc.find("head"),
                $body = $doc.find("body"),
                $base = $('base'),
                baseURL;

            // add base tag to ensure elements use the parent domain
            if (this.opt.base === true && $base.length > 0) {
                // take the base tag from the original page
                baseURL = $base.attr('href');
            } else if (typeof this.opt.base === 'string') {
                // An exact base string is provided
                baseURL = this.opt.base;
            } else {
                // Use the page URL as the base
                baseURL = document.location.protocol + '//' + document.location.host;
            }

            $head.append('<base href="' + baseURL + '">');
            $head.append('<style>html,body{margin:0!important;padding:0!important;}*{box-sizing:border-box;}@media print{@page{size:A5 portrait;margin:4mm;}body{zoom:0.78;}}</style>');

            // import page stylesheets
            if (this.opt.importCSS) $("link[rel=stylesheet]").each(function() {
                var href = $(this).attr("href");
                if (href) {
                    var media = $(this).attr("media") || "all";
                    $head.append("<link type='text/css' rel='stylesheet' href='" + href + "' media='" + media + "'>");
                }
            });

            // import style tags
            if (this.opt.importStyle) $("style").each(function() {
                //$(this).clone().appendTo($head);
            });

            // add title of the page
            if (this.opt.pageTitle) $head.append("<title>" + this.opt.pageTitle + "</title>");

            // import additional stylesheet(s)
            if (this.opt.loadCSS) {
                if ($.isArray(this.opt.loadCSS)) {
                    jQuery.each(this.opt.loadCSS, function(index, value) {
                        $head.append("<link type='text/css' rel='stylesheet' href='" + this + "'>");
                    });
                } else {
                    $head.append("<link type='text/css' rel='stylesheet' href='" + this.opt.loadCSS + "'>");
                }
            }

            // copy 'root' tag classes
            var tag = this.opt.copyTagClasses;
            if (tag) {
                tag = tag === true ? 'bh' : tag;
                if (tag.indexOf('b') !== -1) {
                    $body.addClass($('body')[0].className);
                }
                if (tag.indexOf('h') !== -1) {
                    $doc.find('html').addClass($('html')[0].className);
                }
            }

            // print header
            this.appendContent($body, this.opt.header);

            if (this.opt.canvas) {
                // add canvas data-ids for easy access after cloning.
                var canvasId = 0;
                $element.find('canvas').each(function(){
                    $(this).attr('data-printthis', canvasId++);
                });
            }

            this.appendBody($body, $element, this.opt);

            /*if (this.opt.canvas) {
                // Re-draw new canvases by referencing the originals
                $body.find('canvas').each(function(){
                    var cid = $(this).data('printthis'),
                        $src = $('[data-printthis="' + cid + '"]');

                    this.getContext('2d').drawImage($src[0], 0, 0);

                    // Remove the markup from the original
                    $src.removeData('printthis');
                });
            }*/

            // capture form/field values
            if (this.opt.formValues) {
                // loop through inputs
                var $input = $element.find('input');
                if ($input.length) {
                    $input.each(function() {
                        var $this = $(this),
                            $name = $(this).attr('name'),
                            $checker = $this.is(':checkbox') || $this.is(':radio'),
                            $iframeInput = $doc.find('input[name="' + $name + '"]'),
                            $value = $this.val();

                        // order matters here
                        if (!$checker) {
                            $iframeInput.val($value);
                        } else if ($this.is(':checked')) {
                            if ($this.is(':checkbox')) {
                                $iframeInput.attr('checked', 'checked');
                            } else if ($this.is(':radio')) {
                                $doc.find('input[name="' + $name + '"][value="' + $value + '"]').attr('checked', 'checked');
                            }
                        }

                    });
                }

                // loop through selects
                var $select = $element.find('select');
                if ($select.length) {
                    $select.each(function() {
                        var $this = $(this),
                            $name = $(this).attr('name'),
                            $value = $this.val();
                        $doc.find('select[name="' + $name + '"]').val($value);
                    });
                }

                // loop through textareas
                var $textarea = $element.find('textarea');
                if ($textarea.length) {
                    $textarea.each(function() {
                        var $this = $(this),
                            $name = $(this).attr('name'),
                            $value = $this.val();
                        $doc.find('textarea[name="' + $name + '"]').val($value);
                    });
                }
            } // end capture form/field values

            // remove inline styles
            if (this.opt.removeInline) {
                // $.removeAttr available jQuery 1.7+
                if ($.isFunction($['removeAttr'])) {
                    $doc.find("body *").removeAttr("style");
                } else {
                    $doc.find("body *").attr("style", "");
                }
            }

            // print "footer"
            this.appendContent($body, this.opt.footer);

            setTimeout(()=>{
                if ($iframe.hasClass("MSIE")) {
                    // check if the iframe was created with the ugly hack
                    // and perform another ugly hack out of neccessity
                    window.frames["printIframe"].focus();
                    $head.append("<script>  window.print(); </s" + "cript>");
                } else {
                    // proper method
                    if (document.queryCommandSupported("print")) {
                        $iframe[0]['contentWindow'].document.execCommand("print", false, null);
                    } else {
                        $iframe[0]['contentWindow'].focus();
                        $iframe[0]['contentWindow'].print();
                    }
                }

                // remove iframe after print
                if (!this.opt.debug) {
                    setTimeout(function() {
                        $iframe.remove();
                    }, 1000);
                }

            }, this.opt.printDelay);

        }, 333);
    }
}


// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/shared/print/print.page.ts